import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import Droppable from 'owa-dnd/lib/components/Droppable';
import * as React from 'react';
var DroppableWell = /** @class */ (function (_super) {
    tslib_1.__extends(DroppableWell, _super);
    function DroppableWell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.canDrop = function (dragData) {
            return dragData.itemType === _this.props.draggableItemType;
        };
        _this.onDrop = function (dragData, pageX, pageY, target) {
            if (_this.canDrop(dragData)) {
                var item = dragData.item;
                _this.props.addDroppedItemAction(item);
            }
        };
        return _this;
    }
    DroppableWell.prototype.render = function () {
        return (React.createElement(Droppable, { dropViewState: this.props.dropViewState, canDrop: this.canDrop, onDrop: this.onDrop }, this.props.children));
    };
    DroppableWell = tslib_1.__decorate([
        observer
    ], DroppableWell);
    return DroppableWell;
}(React.Component));
export default DroppableWell;
//# sourceMappingURL=DroppableWell.js.map